<template>
  <mobile-button
    :is-scaled="false"
    :disabled="inputsState.disabled"
    :type="type"
    @mousedown="performAction"
    @mouseup="endAction"
    @touchstart="performAction"
    @touchend="endAction"
  />
</template>

<script lang="ts">
import { MobileButton } from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import { inputsManager } from '@powerplay/core-minigames'
import {
  actionButtonState,
  inputsState
} from '@/stores'

export default defineComponent({
  name: 'ActionButton',
  components: {
    MobileButton
  },
  data() {

    return {
      inputsState: inputsState(),
    }

  },
  computed: {
    type() {

      if (actionButtonState().isJumpIn) return 'jump-in'
      return 'bobsleigh-push'

    }
  },
  methods: {
    performAction() {

      if (this.type === 'bobsleigh-push') {

        actionButtonState().touchStart = true

      }

      if (this.type === 'jump-in') {

        actionButtonState().touchJumpIn = true

      }

    },
    endAction() {

      if (this.type === 'bobsleigh-push') {

        actionButtonState().touchStart = false

      }
      if (this.type === 'jump-in') {

        actionButtonState().touchJumpIn = false

      }

      // musime dat manulane ukoncenie buttonu, aby sa ukoncil takisto actionPressed v inputs
      inputsManager.handleMouseUp()

    }
  }
})
</script>

<style>

</style>
